import type { PrivacyPolicyData } from "../consent/policy";

/**
 * Example statement for the block chooser's previews of the privacy blocks
 * (`sample.data`). Illustrative only: the real blocks render the site's own
 * generated statement.
 */
export const SAMPLE_PRIVACY_POLICY: PrivacyPolicyData = {
  locale: "nl",
  tracking: true,
  choices: true,
  lastChanged: null,
  untranslated: 0,
  sections: [
    { id: "who", heading: "Wie wij zijn", html: "<p>Voorbeeld B.V. is verantwoordelijk voor de verwerking van persoonsgegevens op deze website.</p>" },
    { id: "data", heading: "Welke gegevens wij verwerken", html: "<p>Als je de website bezoekt, verwerken wij alleen de gegevens die nodig zijn om de website te laten werken.</p>" },
    { id: "cookies", heading: "Cookies", html: "<p>Met jouw toestemming plaatsen wij cookies voor statistieken. Je kunt je keuze altijd wijzigen.</p>" },
  ],
  cookies: [
    { category: "necessary", label: "Noodzakelijk", services: [{ name: "Cookievoorkeuren", provider: "Voorbeeld B.V.", purpose: "Onthoudt je cookiekeuze", basis: "Noodzakelijk", cookies: [{ name: "cms_consent", retention: "6 maanden" }] }] },
    { category: "analytics", label: "Statistieken", services: [{ name: "Google Analytics", provider: "Google", purpose: "Anonieme bezoekstatistieken", basis: "Toestemming", cookies: [{ name: "_ga", retention: "13 maanden" }] }] },
  ],
};
